import React from 'react'
import { NavLink } from 'react-router-dom';

const AskAQuery = () => {
  return (
    <div className="query-box"><NavLink to="/add-query" className="query-btn"><span className="material-icons-outlined">message</span> Ask a Query</NavLink></div>
  )
}

export default AskAQuery;